<template>
  <section class="content-section" style="background: #ffffff;">
    <div class="content-inner">
      <div class="section-title">
        <div class="title-main">PRICING PLANS</div>
        <div class="title-sub">解析价格 <span class="slash">//</span> PRICING</div>
      </div>

      <div v-if="packages.length > 0" class="pricing-grid">
        <div
          v-for="pkg in packages"
          :key="pkg.id"
          class="price-card"
        >
          <div class="price-content">
            <div class="price-header">
              <h3>{{ pkg.name }}</h3>
              <p>域名: {{ pkg.url_name }}</p>
            </div>
            <div class="price-value">
              ¥{{ formatPrice(pkg.price) }} <span>/次</span>
            </div>
            <ul class="price-features">
              <li>解析次数: {{ pkg.parse_count }} 次</li>
              <li>域名: {{ pkg.url_name }}</li>
              <li>24小时技术支持</li>
              <li>99.9%稳定性保证</li>
            </ul>
            <a href="/user" class="price-btn">立即开启 START</a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { packages } from '../data/data.js'

function formatPrice(price) {
  return Number(price || 0).toFixed(2)
}
</script>
